<!-- <div class="container titulo-box ">
  <div class="row m-none" style="height: 2rem;">
    <h2 mat-dialog-title class="mc-vert-tb">{{ header }}</h2>
  </div>
</div> -->
<mat-dialog-content>
  <div class="container mt-2">
    <div class="row">
      <div class="col-12 text-center">
        {{ message }}
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="mb-2">
  <div class="row m-none m-0">
    <button mat-raised-button mat-dialog-close class="mr-2 w-button button-actions">Cerrar</button>
  </div>
</mat-dialog-actions>
